import { ProductBlock } from './product_block';
import { ProductGallery } from "./product_gallery";

export class ProductPage {
    constructor(loader, cart, body, popup) {
        this.loader = loader;
        this.cart = cart;
        this.popup = popup;


        const
            productSection = jQuery('.v4-single-product-section'),
            galleryContainer = productSection.find('.v4-product-gallery'),
            blockContainer = productSection.find('.v4-product-block'),
            gallery = new ProductGallery(this.loader, galleryContainer, blockContainer);
        this.block = new ProductBlock(loader, cart, blockContainer, {}, {class_ProductPage: true});
        this.popup.attachForm(this.block.form);
    }
}
